/**
 * @description Map utils whitch base on openlayer javascript library
 * @author Create by zcg at 2020年08月26日21:01:45
 * */

import {Cluster, OSM, Vector as VectorSource} from 'ol/source';
import {Tile as TileLayer} from "ol/layer";
import TileWMS from "ol/source/TileWMS";
import View from 'ol/View';
import Map from 'ol/Map';
import { Point } from "ol/geom";
import {ScaleLine, defaults as defaultControls} from 'ol/control';
import {relativeTimeRounding} from "moment";
import { createUUID } from './mapExt';



class IHMapUtils{

  /**
   * @description Class constructor function
   * */
  constructor() {
    //this.defaultGeoserver="http://47.104.62.144:8080/geoserver/BSD/wms/";
    this.defaultGeoserver="/geo_bsd/geoserver/bsd/wms/";
  }


  /**
   * @description init the openlayer object
   * @param {Object} map  the map object
   * @param {Array} center the init map center
   * @param {Number} initZoom the default map zoom
   * @param {Number} minZoom:the min map zoom
   * @param {Number} maxZoom:the max value of map zoom
   * @param {String} geoserver:the default geoserver acccess address
   * @param {String} projection:the default map projection
   * */
  init({map=null,center=[104.981847,34.621715],projection="EPSG:4326",initZoom=1,minZoom=1,maxZoom=19,geoserver=null}) {
    if(this.map !=undefined){
      this.map.getLayers().forEach(item=>{
        this.map.removeLayer(item);
      })
      this.map = undefined;
    }
    this.map = new Map({
      target: map,
      view: new View({
        projection,
        center,
        zoom: initZoom,
        maxZoom,
        minZoom
      }),
      controls: defaultControls().extend([
        new ScaleLine({
          units: 'metric',
        })
      ]),
    });
    this.geoserver = geoserver;
    return this.map;
  }

  /**
   * @description Get the map property
   * */
  getMap(){return this.map;}

  /**
   * @description add map layer
   * @param {Object} layer  map layer object
   * */
  addLayer(layer) {this.map.addLayer(layer);}

  /**
   * @description  add default OSM
   * */
  addOSM() {this.map.addLayer(new TileLayer({source: new OSM()}));}


  /**
   * @description 读取WMS Source
   * */
  getWMSSource(workspace,layerCode){
    let layer_params = {
      'LAYERS': layerCode,
      'TILED': true,
    };
    let _geoserver = this.geoserver;
    _geoserver = _geoserver.replace("BSD",workspace);
    console.log("getWMSSource = ",_geoserver);
    let wmsSource = new TileWMS({
      wrapX:true,
      projection:"EPSG:4326",
      // crossOrigin:'anonymous',
      url: _geoserver,
      params: layer_params,
      serverType: 'geoserver',
      transition: 1
    });
    console.log("wmsSource = ",wmsSource);
    return wmsSource;
  }



  /**
   * @description Add map layer which comes from geoserver service
   * @param {String}  geoServer       开源地图服务引擎
   * @param {String}  layerCode       Geoserver地图图层编码
   * @param {Boolean} visible         图层是否可见
   * @param {String}  layerName       图层名称
   * @param {Number} zIndex           图层渲染顺序
   * @param {Boolean} wrapX           地图在X轴方向是否可以循环
   * @param {String} tag
   * */
  addWMSLayer({geoServer=null,layerCode,layerName=null,visible=true,zIndex=0,
                wrapX=true,
                projection="EPSG:4326",defaultStyles=undefined,olTag="default",styles=''})
  {
    layerCode = layerCode.toLowerCase();
    layerName = layerName.toLowerCase();


    let _geoserver = geoServer ? geoServer : this.geoserver;
    if (_geoserver == undefined) {
      console.log("geoserver is not define && return");
      return;
    }

    if(layerCode!=undefined){
      let layer_code_segs = layerCode.split(":");
      if(layer_code_segs.length==0){
        layerCode = layerCode.toLowerCase();
      }else if(layer_code_segs.length==2){
        let seg_0 = layer_code_segs[0];
        let seg_1 = layer_code_segs[1];
        layerCode = seg_0.toLowerCase() +":"+seg_1;
      }
    }


    let layer_params = {
      SERVICE:'WMS',
      LAYERS: layerCode,
      TILED:true,
    };

    if (layerName == undefined && layerCode != undefined) {
      layerName = layerCode;//set layercode as the default layer_name
    }

    if(defaultStyles!=undefined) {
      console.log("defaultStyles!=undeinfed && rener coors");
      layer_params = {
        SERVICE:'WMS',
        tiled: false  ,
        sld_body:defaultStyles
      };
    }

    let map_layer= new TileLayer({
      visible:visible,
      source: new TileWMS({
        wrapX:wrapX,
        projection:projection,
        // crossOrigin:'anonymous',
        url: _geoserver,
        params: layer_params,
        serverType: 'geoserver',
        transition: 1
      }),
    });
    map_layer.name = layerName;
    map_layer.setZIndex(zIndex);
    map_layer.olTag = olTag;
    this.map.addLayer(map_layer);
    return map_layer;
  }


  createWMSLayer (serviceParams) {
    let wmslayer = null;
    // 先检查创建wmts服务的参数是否全部具备
    if(!serviceParams.hasOwnProperty('url') || !serviceParams.hasOwnProperty('layer') ){
      console.error('服务参数缺少必要的属性！');
      return null;
    }
    // 图层所需要的参数
    let layerParams = {
      id: serviceParams.serviceId || createUUID(),
      visible: true,
      title: serviceParams.layerName||'wms图层',
      layerType: serviceParams.layerType || '-1',
      layerIndex: serviceParams.layerIndex || '-1'
    }
    if(!!serviceParams.defaultSelect && serviceParams.defaultSelect === 'false') {layerParams.visible = false;}

    let offlevelNum = 0;
    if(serviceParams.hasOwnProperty('offlevel')){
      offlevelNum = parseInt(serviceParams.offlevel , 10);
    }
    wmslayer = new TileLayer({
      title: layerParams.title,
      visible: layerParams.visible,
      source: new TileWMS({
        version: serviceParams.version || '1.3.0',
        format: serviceParams.format || 'image/png',
        // dimensions: serviceParams.dimensions || {},
        params:{
          LAYERS: serviceParams.layer,
          TILED: true
        },
        serverType: serviceParams.serviceType,
        // matrixSet: serviceParams.matrixSet,
        // tileGrid: serviceParams.tileGrid || getTileGrid(serviceParams.projection || 'EPSG:4326' , offlevelNum),
        style: serviceParams.style || 'default',
        // cacheSize: serviceParams.cacheSize,
        // crossOrigin: serviceParams.crossOrigin,
        // opaque: serviceParams.opaque || true,
        // maxZoom: serviceParams.maxZoom || 19,
        // reprojectionErrorThreshold: serviceParams.reprojectionErrorThreshold,
        // tileLoadFunction: serviceParams.tileLoadFunction,
        url: serviceParams.url,
        // urls: serviceParams.urls,
        projection: serviceParams.projection || 'EPSG:4326',
        // wrapX: serviceParams.wrapX
      })
    })

    wmslayer.set('serviceId',layerParams.id);
    wmslayer.set('layerType',layerParams.layerType);
    wmslayer.set('layerIndex',layerParams.layerIndex);
    wmslayer.set('serviceParams',serviceParams);
    wmslayer.setZIndex(100);
    return wmslayer;
  }






  removeLayerByName(map,layer_name)
  {
    let selectedLayer =this.getLayerByName(map,layer_name);
    if(selectedLayer){
      this.map.removeLayer(selectedLayer);
    }
  }

  /**
   * 数组倒置
   * */
  colorGroupReverse(data){
    let deep_obj = JSON.parse(JSON.stringify(data));
    let legendsData_reverse = [];
    for(let i=deep_obj.length-1;i>=0;i--){
      //更新于2020年12月14日21:31:20
      let item = deep_obj[i];
      if(item.label=="NO DATA"){
        //过滤掉NO DATA 的数据
        continue;
      }
      //console.log("item = ",item);
      if(item.color ==null || item.color ==undefined){
        item.color = "#FFFFFF";
        item.opacity = 0;
      }
      else {
        item.opacity = 1;
      }
      legendsData_reverse.push(item);
    }
    return legendsData_reverse;
  }

  /**
   * 数组倒置
   * */
  colorGroupReverse_NODATA_BLACK(data){
    let deep_obj = JSON.parse(JSON.stringify(data));
    let legendsData_reverse = [];
    for(let i=deep_obj.length-1;i>=0;i--){
      let item = deep_obj[i];
      let item_title = item.label;
      item_title = item_title.trim();
      if(item_title=="NO DATA"){
        continue;
      }
      legendsData_reverse.push(item);
    }
    return legendsData_reverse;
  }

  colorGroupReverse_NODATA_BLACK_BK_2021年4月24日(data){
    let deep_obj = JSON.parse(JSON.stringify(data));
    let legendsData_reverse = [];
    for(let i=deep_obj.length-1;i>=0;i--){
      //更新于2020年12月14日21:31:20
      let item = deep_obj[i];
      //console.log("item = ",item);
      if(item.color ==null || item.color ==undefined){
        item.color = "#221815";
        item.opacity = 1;
      }
      else {
        item.opacity = 1;
      }
      legendsData_reverse.push(item);
    }
    return legendsData_reverse;
  }

  /**
   * 解析SLDBody
   * */
  parseSLDBody(x2js,layer_code,color_gropu){

    let parsed_layer_code = layer_code.split(":");
    if(parsed_layer_code!=undefined && parsed_layer_code.length>1){
      layer_code = parsed_layer_code[parsed_layer_code.length-1];
    }

    let xmlStr = '<?xml version="1.0" encoding="UTF-8"?><sld:StyledLayerDescriptor xmlns="http://www.opengis.net/sld" xmlns:sld="http://www.opengis.net/sld" xmlns:gml="http://www.opengis.net/gml" xmlns:ogc="http://www.opengis.net/ogc" version="1.0.0">\n' +
      '  <sld:NamedLayer>\n' +
      '    <sld:Name>risk_rice_mean_2000s_s0_value_mme_global</sld:Name>\n' +
      '    <sld:UserStyle>\n' +
      '      <sld:Name>risk_rice_mean_2000s_s0_value_mme_global</sld:Name>\n' +
      '      <sld:FeatureTypeStyle>\n' +
      '        <sld:Name>risk_rice_mean_2000s_s0_value_mme_global</sld:Name>\n' +
      '        <sld:Rule>\n' +
      '          <sld:RasterSymbolizer>\n' +
      '            <sld:ChannelSelection>\n' +
      '              <sld:GrayChannel>\n' +
      '                <sld:SourceChannelName>1</sld:SourceChannelName>\n' +
      '                <sld:ContrastEnhancement>\n' +
      '                  <sld:GammaValue>1.0</sld:GammaValue>\n' +
      '                </sld:ContrastEnhancement>\n' +
      '              </sld:GrayChannel>\n' +
      '            </sld:ChannelSelection>\n' +
      '            <sld:ColorMap type="RAMP" extended="true">\n' +
      '              <sld:ColorMapEntry color="#FF00FF" quantity="1" label="&lt;=1" opacity="1" />\n' +
      '              <sld:ColorMapEntry color="#0000FF" quantity="2" label="1-2" opacity="1" />\n' +
      '              <sld:ColorMapEntry color="#4682B4" quantity="3" label="2-3" opacity="1" />\n' +
      '              <sld:ColorMapEntry color="#FF0000" quantity="5" label="3-5" opacity="1" />\n' +
      '              <sld:ColorMapEntry color="#90EE90" quantity="8" label="5-8" opacity="1" />\n' +
      '              <sld:ColorMapEntry color="#DA70D6" quantity="13" label="0"  opacity="1" />\n' +
      '            </sld:ColorMap>\n' +
      '            <sld:ContrastEnhancement/>\n' +
      '          </sld:RasterSymbolizer>\n' +
      '        </sld:Rule>\n' +
      '      </sld:FeatureTypeStyle>\n' +
      '    </sld:UserStyle>\n' +
      '  </sld:NamedLayer>\n' +
      '</sld:StyledLayerDescriptor>\n';

    let jsonObj = x2js.xml2js(xmlStr);

    console.log("jsonObj = ",jsonObj);

    //修改名称
    jsonObj.StyledLayerDescriptor.NamedLayer.Name = {
      __prefix:"sld",
      __text:layer_code
    };
    jsonObj.StyledLayerDescriptor.NamedLayer.UserStyle.Name = {
      __prefix:"sld",
      __text:layer_code
    };
    jsonObj.StyledLayerDescriptor.NamedLayer.UserStyle.FeatureTypeStyle.Name = {
      __prefix:"sld",
      __text:layer_code
    };


    //更新SLDColor Map
    let colorMaps = [];
    color_gropu.forEach(item=>{
      colorMaps.push({
        _color:item.color,
        _quantity:item.quantity,
        _opacity:item.opacity,
        _label:item.label,
        __prefix:"sld"
      })
    });
    jsonObj.StyledLayerDescriptor.NamedLayer.UserStyle.FeatureTypeStyle.Rule.RasterSymbolizer.ColorMap.ColorMapEntry = colorMaps;
    let stylStr = '<?xml version="1.0" encoding="UTF-8"?>'+ x2js.js2xml(jsonObj);
    return stylStr;
  }


  /**
   * 解析SLDBody
   * */
  parseSLDBodyWithType(x2js,layer_code,color_gropu,colorMapEntryType){

    let parsed_layer_code = layer_code.split(":");
    if(parsed_layer_code!=undefined && parsed_layer_code.length>1){
      layer_code = parsed_layer_code[parsed_layer_code.length-1];
    }

    // let xmlStr = '<?xml version="1.0" encoding="UTF-8"?><sld:StyledLayerDescriptor xmlns="http://www.opengis.net/sld" xmlns:sld="http://www.opengis.net/sld" xmlns:gml="http://www.opengis.net/gml" xmlns:ogc="http://www.opengis.net/ogc" version="1.0.0">\n' +
    //   '  <sld:NamedLayer>\n' +
    //   '    <sld:Name>risk_rice_mean_2000s_s0_value_mme_global</sld:Name>\n' +
    //   '    <sld:UserStyle>\n' +
    //   '      <sld:Name>risk_rice_mean_2000s_s0_value_mme_global</sld:Name>\n' +
    //   '      <sld:FeatureTypeStyle>\n' +
    //   '        <sld:Name>risk_rice_mean_2000s_s0_value_mme_global</sld:Name>\n' +
    //   '        <sld:Rule>\n' +
    //   '          <sld:RasterSymbolizer>\n' +
    //   '            <sld:ChannelSelection>\n' +
    //   '              <sld:GrayChannel>\n' +
    //   '                <sld:SourceChannelName>1</sld:SourceChannelName>\n' +
    //   '                <sld:ContrastEnhancement>\n' +
    //   '                  <sld:GammaValue>1.0</sld:GammaValue>\n' +
    //   '                </sld:ContrastEnhancement>\n' +
    //   '              </sld:GrayChannel>\n' +
    //   '            </sld:ChannelSelection>\n' +
    //   '            <sld:ColorMap type="RAMP" extended="true">\n' +
    //   '              <sld:ColorMapEntry color="#FF00FF" quantity="1" label="&lt;=1" opacity="1" />\n' +
    //   '              <sld:ColorMapEntry color="#0000FF" quantity="2" label="1-2" opacity="1" />\n' +
    //   '              <sld:ColorMapEntry color="#4682B4" quantity="3" label="2-3" opacity="1" />\n' +
    //   '              <sld:ColorMapEntry color="#FF0000" quantity="5" label="3-5" opacity="1" />\n' +
    //   '              <sld:ColorMapEntry color="#90EE90" quantity="8" label="5-8" opacity="1" />\n' +
    //   '              <sld:ColorMapEntry color="#DA70D6" quantity="13" label="0"  opacity="1" />\n' +
    //   '            </sld:ColorMap>\n' +
    //   '            <sld:ContrastEnhancement/>\n' +
    //   '          </sld:RasterSymbolizer>\n' +
    //   '        </sld:Rule>\n' +
    //   '      </sld:FeatureTypeStyle>\n' +
    //   '    </sld:UserStyle>\n' +
    //   '  </sld:NamedLayer>\n' +
    //   '</sld:StyledLayerDescriptor>\n';


    let xmlStr = '<?xml version="1.0" encoding="UTF-8"?>\n' +
      '<sld:StyledLayerDescriptor\n' +
      '    xmlns="http://www.opengis.net/sld"\n' +
      '    xmlns:sld="http://www.opengis.net/sld"\n' +
      '    xmlns:gml="http://www.opengis.net/gml"\n' +
      '    xmlns:ogc="http://www.opengis.net/ogc" version="1.0.0">\n' +
      '    <sld:NamedLayer>\n' +
      '        <sld:Name>CC_prcptot_JJA_mean_2050s_RCP85_VALUE_MMS_Global_20070318</sld:Name>\n' +
      '        <sld:UserStyle>\n' +
      '            <sld:Name>CC_prcptot_JJA_mean_2050s_RCP85_VALUE_MMS_Global_20070318</sld:Name>\n' +
      '            <sld:FeatureTypeStyle>\n' +
      '                <sld:Name>name</sld:Name>\n' +
      '                <sld:Rule>\n' +
      '                    <sld:RasterSymbolizer>\n' +
      '                        <sld:ColorMap type="RAMP" extended="true">\n' +
      '                            <sld:ColorMapEntry quantity="0.0" label="&lt;=0" color="#221815"/>\n' +
      '                            <sld:ColorMapEntry quantity="0.01" label="0-0.3" color="#009fb4"/>\n' +
      '                            <sld:ColorMapEntry quantity="3000" label="0.3-5" color="#bcc800"/>\n' +
      '                            <sld:ColorMapEntry quantity="50000" label="5-50" color="#ffda01"/>\n' +
      '                            <sld:ColorMapEntry quantity="500000" label="50-800" color="#f0831e"/>\n' +
      '                            <sld:ColorMapEntry quantity="8000000" label=">800" color="#d83166"/>\n' +
      '                        </sld:ColorMap>\n' +
      '                        <sld:ContrastEnhancement/>\n' +
      '                    </sld:RasterSymbolizer>\n' +
      '                </sld:Rule>\n' +
      '            </sld:FeatureTypeStyle>\n' +
      '        </sld:UserStyle>\n' +
      '    </sld:NamedLayer>\n' +
      '</sld:StyledLayerDescriptor>\n';



    if(colorMapEntryType!=undefined){
      xmlStr = xmlStr.replace("RAMP",colorMapEntryType);
    }


    let jsonObj = x2js.xml2js(xmlStr);

    console.log("jsonObj = ",jsonObj);

    //修改名称
    jsonObj.StyledLayerDescriptor.NamedLayer.Name = {
      __prefix:"sld",
      __text:layer_code
    };
    jsonObj.StyledLayerDescriptor.NamedLayer.UserStyle.Name = {
      __prefix:"sld",
      __text:layer_code
    };
    jsonObj.StyledLayerDescriptor.NamedLayer.UserStyle.FeatureTypeStyle.Name = {
      __prefix:"sld",
      __text:layer_code
    };


    //更新SLDColor Map
    let colorMaps = [];
    color_gropu.forEach(item=>{
      colorMaps.push({
        _color:item.color,
        _quantity:item.quantity,
        // _opacity:item.opacity, //注释掉 2021年4月24日10:40:35
        _label:item.label,
        __prefix:"sld"
      })
    });




    jsonObj.StyledLayerDescriptor.NamedLayer.UserStyle.FeatureTypeStyle.Rule.RasterSymbolizer.ColorMap.ColorMapEntry = colorMaps;
    let stylStr = '<?xml version="1.0" encoding="UTF-8"?>'+ x2js.js2xml(jsonObj);
    return stylStr;
  }




  getSlDBody(){
    let layer_name = "risk_rice_mean_2000s_s0_value_mme_global";
    return '<?xml version="1.0" encoding="UTF-8"?><sld:StyledLayerDescriptor xmlns="http://www.opengis.net/sld" xmlns:sld="http://www.opengis.net/sld" xmlns:gml="http://www.opengis.net/gml" xmlns:ogc="http://www.opengis.net/ogc" version="1.0.0">\n' +
      '<sld:NamedLayer>\n' +
      '  <sld:Name>risk_rice_mean_2000s_s0_value_mme_global</sld:Name>\n' +
      '  <sld:UserStyle>\n' +
      '    <sld:Name>risk_rice_mean_2000s_s0_value_mme_global</sld:Name>\n' +
      '    <sld:FeatureTypeStyle>\n' +
      '      <sld:Name>risk_rice_mean_2000s_s0_value_mme_global</sld:Name>\n' +
      '      <sld:Rule>\n' +
      '        <sld:RasterSymbolizer>\n' +
      '          <sld:ChannelSelection>\n' +
      '            <sld:GrayChannel>\n' +
      '              <sld:SourceChannelName>1</sld:SourceChannelName>\n' +
      '              <sld:ContrastEnhancement>\n' +
      '                <sld:GammaValue>1.0</sld:GammaValue>\n' +
      '              </sld:ContrastEnhancement>\n' +
      '            </sld:GrayChannel>\n' +
      '          </sld:ChannelSelection>\n' +
      '          <sld:ColorMap type="RAMP" extended="true">\n' +
      '            <sld:ColorMapEntry color="#FF00FF" quantity="1" label="&lt;=1"/>\n' +
      '            <sld:ColorMapEntry color="#FF00FF" quantity="2" label="1-2"/>\n' +
      '            <sld:ColorMapEntry color="#8B008B" quantity="3" label="2-3"/>\n' +
      '            <sld:ColorMapEntry color="#B0C4DE" quantity="5" label="3-5"/>\n' +
      '            <sld:ColorMapEntry color="#D4F2E7" quantity="8" label="5-8"/>\n' +
      '            <sld:ColorMapEntry color="#20B2AA" quantity="13" label="0"/>\n' +
      '          </sld:ColorMap>\n' +
      '          <sld:ContrastEnhancement/>\n' +
      '        </sld:RasterSymbolizer>\n' +
      '      </sld:Rule>\n' +
      '    </sld:FeatureTypeStyle>\n' +
      '  </sld:UserStyle>\n' +
      '</sld:NamedLayer>\n' +
      '</sld:StyledLayerDescriptor>\n'
  }





  readWMSLayer({geoServer=null,layerCode,layerName=null,visible=true,zIndex=null,wrapX=true,projection="EPSG:4326"}) {
    let _geoserver = geoServer?geoServer:this.geoserver;
    if(_geoserver==undefined) {
      console.log("geoserver is not define && return");
      return;
    }

    if(layerName==undefined&&layerCode!=undefined) {
      layerName = layerCode;//set layercode as the default layer_name
    }


    let map_layer= new TileLayer({
      visible:visible,
      source: new TileWMS({
        wrapX:wrapX,
        projection:projection,
        // crossOrigin:'anonymous',
        url: _geoserver,
        params: {
          'LAYERS': layerCode,
          'TILED': true,
        },
        serverType: 'geoserver',
        transition: 1
      }),
    });
    map_layer.name = layerName;
    if(zIndex) {
      map_layer.setZIndex(zIndex);
    }
    return map_layer;
  }


  /**
   * 根据图层名称查看图层对应的图层
   * 备注:图层必须有一个name属性
   * */
  getLayerByName(map,layerName){
    let selectedLayer = undefined;
    const mapLayers = map.getLayers();
    mapLayers.forEach(item=>{
      //console.log("Layer name = ",item.name);
      if(item.name ==layerName)
      {
        selectedLayer = item;
      }
    });
    return selectedLayer;
  };


  setLayerVisibleWithOlTag(olTag,visible){
    this.map.getLayers().forEach(item=>{
      console.log("item.olTag = ",item);
      if(item.olTag !=undefined && item.olTag==olTag){
        item.setVisible(visible);
      }
    })
  };


  /**
   * @description Class Test Function
   * */
  toString(){
    console.log("*******");
  }


  updateOceanMapLayer(map,selected_cascader_laster){
    console.log("updateOceanMapLayer::selected_cascader_laster = ",selected_cascader_laster);
    let oceanLayerName = undefined;
    if(selected_cascader_laster=="2030s") {
      oceanLayerName = "BSD:ocean_2030";
    }else if(selected_cascader_laster=="2050s") {
      oceanLayerName = "BSD:ocean_2050";
    }else{
      oceanLayerName = "BSD:ocean";
    }


    let ocean_baseline_layer = this.getLayerByName(map,"BSD:ocean");
    if(ocean_baseline_layer!=undefined){
      ocean_baseline_layer.setVisible(false);
    }

    let ocean_baseline_2030 =  this.getLayerByName(map,"BSD:ocean_2030");
    if(ocean_baseline_2030!=undefined){
      ocean_baseline_2030.setVisible(false);
    }

    let ocean_baseline_2050 =  this.getLayerByName(map,"BSD:ocean_2050");
    if(ocean_baseline_2050!=undefined){
      ocean_baseline_2050.setVisible(false);
    }

    let selected_oceanLayer = this.getLayerByName(map,oceanLayerName);
    if(selected_oceanLayer==undefined){
      this.basicOceanLayer =this.addWMSLayer({layerName:oceanLayerName, layerCode:oceanLayerName, visible:true,zIndex:9,});
    }else {
      selected_oceanLayer.setVisible(true);
    }
  }



}

export {IHMapUtils}



// WEBPACK FOOTER //
// ./src/components/map/common/IHMapUtils.js